export default {
  projects: [],
};
